import MegaSaleLayout, { MegaSaleLayoutProps } from '@v2/shared/Layouts/MegaSale';

import Footer from '../Full/Footer';
import logo from '../Full/Navigation/images/logo.svg';

export type { MegaSaleLayoutProps };

/**
 * The chrome of a TopMags sale page.
 *
 * The shared sale layout with this brand's two facts in it: its mark, and its footer.
 * Everything else — the header's arrangement, the sale's sections behind the hamburger,
 * the scoped search, the cart drawer — is `shared/Layouts/MegaSale`, which MagSpot and
 * MagZoom draw from the same file.
 *
 * The mark is the size the site header draws it at below md (`w-[155px] h-[35px]`). The
 * sale header is one strip rather than Full's two, so it keeps the compact size at every
 * width instead of growing to 192px at md.
 *
 * `Footer` takes no `copyrightYear`: this layout's props are the sale's, so there is none
 * to pass, and `SiteCopyright` falls back to reading the clock. Safe here where it would
 * not be on a cached page — `blackfriday.html` mounts with `SsrOptions::disabled()`,
 * so there is no server-rendered year for the browser to disagree with.
 */
export default function MegaSale(props: MegaSaleLayoutProps) {
  return (
    <MegaSaleLayout
      {...props}
      logo={{ src: logo, width: 192, height: 44, className: 'w-[155px] h-[35px] block' }}
      footer={<Footer />}
    />
  );
}
